
const CircleLoader = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="84"
      height="84"
      viewBox="0 0 84 84"
      fill="none"
    >
      <circle cx="14" cy="42" r="12" stroke="#1E96F2" strokeWidth="4" />
      <circle cx="42" cy="70" r="12" stroke="#1E96F2" strokeWidth="4" />
      <circle cx="70" cy="42" r="12" stroke="#1E96F2" strokeWidth="4" />
      <circle cx="42" cy="14" r="12" stroke="#1E96F2" strokeWidth="4" />
    </svg>
  );
};

export default CircleLoader;
